import { AiOutlineQuestionCircle } from "react-icons/ai";
import { Tooltip } from "react-tooltip";

interface IOption {
  name: string;
  tooltip?: string;
}

const CheckboxOption = ({
  option,
  filtersArray,
  setActuallFilters,
}: {
  option: IOption;
  filtersArray: string[];
  setActuallFilters: (arr: string[]) => void;
}) => {
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checkboxName = event.target.value;

    if (event.target.checked) {
      const updatedFiltersArray = [...filtersArray, checkboxName];
      setActuallFilters(updatedFiltersArray);
    } else {
      const updatedFiltersArray = filtersArray.filter(
        (item) => item !== checkboxName
      );
      setActuallFilters(updatedFiltersArray);
    }
  };

  return (
    <div key={option.name} className="grid-x align-middle option-item">
      <div className="cell shrink" style={{ flex: "none" }}>
        <input
          type="checkbox"
          id={option.name}
          name={option.name}
          value={option.name}
          className="primary-color"
          onChange={handleCheckboxChange}
          style={{ width: 18, height: 18 }}
        />
      </div>
      <div
        className="cell auto"
        style={{ display: "flex", alignItems: "center" }}
      >
        <div style={{ padding: " 12px 4px" }}>
          <span style={{ userSelect: "none" }}>{option.name}</span>
        </div>
        {option.tooltip && (
          <div
            className={`my-anchor-element ${option.name}-icon`}
            style={{
              display: "flex",
              alignItems: "center",
              marginLeft: "4px",
              fontSize: "19px",
            }}
          >
            <AiOutlineQuestionCircle />
          </div>
        )}
      </div>
      {option.tooltip && (
        <Tooltip
          anchorSelect={`.${option.name}-icon`}
          place="top"
          style={{
            backgroundColor: "white",
            padding: 28,
            color: "black",
          }}
        >
          {option.tooltip}
        </Tooltip>
      )}
    </div>
  );
};

export default CheckboxOption;
